import { SeatConfigurationData } from '~admin/model/seat-configuration-data';
import { SeatConfigurationSectionData } from '~client/model/admin/seat-configuration-section-data';
import { SeatConfigurationResponse } from '~client/model/admin/seat-configuration-response';

export const mapSeatConfigurationData = (
  response: SeatConfigurationResponse,
): SeatConfigurationData => {
  const { id, name, seatConfigurationJson } = response;
  const seatConfiguration = JSON.parse(seatConfigurationJson);
  const sectionList: SeatConfigurationSectionData[] = seatConfiguration.seatConfigurationSectionList.map(
    (section: SeatConfigurationSectionData, index: number): SeatConfigurationSectionData => ({
      ...section,
      code: section.code ?? index + 1,
    }),
  );

  return {
    category: seatConfiguration.category,
    id,
    name,
    sectionList,
  };
};

export const mapSeatConfigurationDataList = (
  response: SeatConfigurationResponse[],
): SeatConfigurationData[] => response.map(mapSeatConfigurationData);



// WEBPACK FOOTER //
// ./model/seat-configuration-data.mapper.ts